import React from "react";
import { Link } from "react-router-dom";
import Feature from "../../components/feature/Feature";
import FadeIn from "react-fade-in";
import "./features.css";

const featuresData = [
  {
    title: "5 Paper Types",
    text: "Research Paper, Business Report, Literature Review, Case Study, and Technical Report — each with its own document type badge so you always know what you're working on.",
  },
  {
    title: "Reference Manager",
    text: "Add journal articles, books, websites, and conference papers directly in the editor. All your sources are saved with the document and never lost.",
  },
  {
    title: "APA Citations",
    text: "Every reference is automatically formatted in APA. Insert an inline citation at your cursor with one click, or copy the full reference to your bibliography.",
  },
  {
    title: "AI Writing Help",
    text: "Get context-aware writing suggestions tailored to your document. Accept, reject, or regenerate until you have exactly what you need.",
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">
        Everything in one place. Free to start, no credit card required.
      </h1>
      <Link to="/authentication/sign-up">
        <p>Create your free account</p>
      </Link>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <FadeIn style={{ transition: "1.5s ease all" }} animateIn="fadeIn" key={item.title + index}>
          <Feature title={item.title} text={item.text} />
        </FadeIn>
      ))}
    </div>
  </div>
);

export default Features;
